import React from 'react';
import { FormattedNumber } from 'react-intl';
import classNames from 'classnames/bind';
import { getTemplateString } from 'common/helpers/string';
import styles from './NewOffer.module.scss';
import PageLink from 'components/PageLink/PageLink';

interface Props {
  PageData?: any;
  Model?: any;
}

const NewOffer = ({ PageData, Model }: Props) => {
  const offerExpires = getTemplateString(PageData?.OfferExpiresText);
  const discountRate = getTemplateString(PageData?.SettlementDiscountLabel);
  const maxNumberOfInstallments = getTemplateString(
    PageData?.SpreadCostUptoLabel,
  );
  if (Model?.HasOffer || Model?.IsCmsEditMode) {
    return (
      <div
        data-type="Promotion"
        data-creative-slot="Portal-Home-Top"
        data-promotion-name="Discounted offer"
      >
        <div className={styles.OfferCard}>
          <div className={styles.expiration}>
            {offerExpires &&
              offerExpires({ DueDate: Model?.Offer?.DueDateText })}
          </div>{' '}
          <div className={styles.content}>
            <h3 className={styles.heading}>{PageData?.OfferHeaderText}</h3>
            <p className={styles.discountInfo}>
              {PageData?.SettlemtnBeginningHeading}{' '}
              <em>
                {discountRate &&
                  discountRate({ DiscountRate: Model?.Offer?.DiscountRate })}
              </em>{' '}
              {PageData?.SettlementEndingHeading}
            </p>
            <p className={styles.discountValue}>
              <em>{PageData?.PayOnlyLabel}</em>
              <span className={styles.price}>
                {Model?.FormattedCurrencyDiscountedDebtBalance}
              </span>
            </p>
            <div
              className={classNames(
                styles.ctaWrapper,
                Model?.Offer?.DirectPaymentUrl === null &&
                  styles.offerCreatePlan,
                Model?.Offer?.StartCreatingPlanUrl === null &&
                  styles.disablebutton,
              )}
            >
              {Model?.Offer?.DirectPaymentUrl !== null && (
                <PageLink
                  url={Model?.Offer?.DirectPaymentUrl?.Uri}
                  className={styles.link}
                  text={PageData?.SettleAccountButtonLabel}
                />
              )}
              {Model?.Offer?.StartCreatingPlanUrl !== null && (
                <PageLink
                  url={Model?.Offer?.StartCreatingPlanUrl?.Uri}
                  className={styles.link}
                >
                  {PageData?.SpreadYourPaymentsButtonLabel}
                </PageLink>
              )}
            </div>
            {Model?.Offer?.StartCreatingPlanUrl !== null && (
              <p className="OfferCard__notice">
                {maxNumberOfInstallments &&
                  maxNumberOfInstallments({
                    MaxNoOfInstallments: Model?.Offer?.MaxNumberOfInstalments,
                  })}{' '}
              </p>
            )}
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default NewOffer;
